<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog">
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon">
                        <div class="h-formBox" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                                <el-form-item label="用户账号/姓名">
                                    <el-input clearable v-model="q.usercodeLikeusernameLike"></el-input>
                                </el-form-item>
                                <el-form-item label="用户类型">
                                    <brselect category="yonghu_leixing" :v="q.usertype"
                                              v-model="q.usertype"  clearable></brselect>
                                </el-form-item>
                                <el-form-item class="h-formBtnOut">
                                    <el-button type="primary"  icon="el-icon-search" @click="handleFilter">搜索</el-button>
                                    <el-button type="primary" @click="selectUser"  icon="el-icon-plus">选择</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
                                :data="ttdata"
								border
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    prop="usercode"
                                    label="账号"
                                    width="150">

                            </el-table-column>
                            <el-table-column
                                    prop="username"
                                    label="姓名"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="email"
                                    label="邮箱"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="status"
                                    label="用户状态"
									:show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{scope.row.status|dictname('zhuangtai_type')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="usertype"
                                    label="用户类型"
									:show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{scope.row.usertype|dictname('yonghu_leixing')}}
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <paginationmin :page="q" @query="queryUser"/>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        name: "alluser",
        data(){
          return {

              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,
                  usercodeLikeusernameLike:null,
              },
              ttdata:null,
              users:[]
          }
        },
        methods: {
            handleFilter(){
                this.queryUser();
            },
            queryUser(p){
                ss.UserService.selectUserPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.ttdata = rd.records;
                })
            },
            //提交
            submitForm(val) {
                // this.$emit('submitForm', this.dialogForm)
            },
            handleSelectionChange(users){
               this.users = users;
            },
            selectUser(){
                var users=[]
                this.$emit('choseUser', this.users)
            },
            //关闭弹窗
            handleCancel() {
                // this.$emit('getCancel')
            },
            //关闭弹窗，不可以删这个方法。不用这个方法点击遮罩层关闭会报错
            handleCloseBindWarnStandard() {
                // this.$emit("closeBindWarnStandard");
            }
        },
        created(){
            this.queryUser()
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
        }
    }
</script>

<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
</style>
